export default __webpack_public_path__ + "static/media/tobasket.f0a34765.svg";